<div class="footer-class"></div>